
import store from "@/store";
import router from "@/router";
import { computed, onMounted } from "@vue/composition-api";
import { ToastProgrammatic } from "buefy";
import i18n from "@core/plugins/i18n";
import { BNoticeConfig } from "buefy/types/components";
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const role = computed(() => store.state.auth.role);
  onMounted(async () => {
    if (store.getters.isUserLogin) {
      if (role.value === "webmaster") {
        await router.push({
          name: "webmaster:finances",
          query: router.currentRoute.query
        });
      } else {
        await router.push({
          name: "dashboard"
        });
        ToastProgrammatic.open({
          message: i18n.t("common.cardsRedirect.invalidRole"),
          type: "is-danger",
          duration: 5000
        } as BNoticeConfig);
      }
    } else {
      await router.push({
        name: "auth:signIn"
      });
    }
  });
  return {};
};
export default __sfc_main;
